import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const closeBar = () => {
    setIsOpen(false);
  };

  return (
    <div className="navbar">
      <div className="logo">
        <Link to="/">Meet Me</Link>
      </div>
      <span className="nav-btn" onClick={handleToggle}>
        <i className="fa fa-bars"></i>
      </span>
      <ul className={isOpen ? "nav show-nav" : "nav"}>
        <li className="nav-item" onClick={closeBar}>
          <Link to="/">Home</Link>
        </li>
        <li className="nav-item" onClick={closeBar}>
          <Link to="/about">About</Link>
        </li>
        <li className="nav-item" onClick={closeBar}>
          <Link to="/services">Services</Link>
        </li>
        <li className="nav-item" onClick={closeBar}>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
